import type { ReactNode } from 'react';
import { Alert, Text } from '@mantine/core';
import { Info } from 'react-feather';

/**
 * Edits on the Configure data step are overrides inside this session's
 * config. matching-server never writes them back to SGOS, so say so where
 * they're made.
 */
export function SessionOnlyNote({ children }: { children: ReactNode }) {
  return (
    <Alert
      color="blue"
      variant="light"
      icon={<Info size={18} />}
      title="Only for this matching session"
    >
      <Text size="sm">{children}</Text>
    </Alert>
  );
}
